import { IFile } from "../domain/models/File";
import { IDevelopmentHistory } from "../domain/models/DevelopmentHistory";
import { IDevelopmentHistoryTranslation } from "../domain/models/DevelopmentHistoryTranslation";
import { BaseModelImpl } from "./BaseModelImpl";

export class DevelopmentHistoryModel extends BaseModelImpl<IDevelopmentHistory> implements IDevelopmentHistory {
    id: string;
    files?: IFile[];
    translations?: IDevelopmentHistoryTranslation[];
    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IDevelopmentHistory) {
        super();
        this.assignData(data);
    }
}
